import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { checkoutUrl, launchOffer } from '../data/content';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 900);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-231" data-mp="3ucvfbyhohrn3">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-night-line bg-night/95 px-4 py-3 backdrop-blur" data-id="element-232" data-mp="3uepzhal4lfq4">
          <div className="mx-auto flex max-w-content items-center justify-between gap-4" data-id="element-233" data-mp="gxh1fdntsfvf">
            <div className="hidden sm:block" data-id="element-234" data-mp="75mbuhazbwh9">
              <p className="font-sans text-sm font-semibold text-parchment" data-id="element-235" data-mp="76nkkf4iw6vt">
                GPS Bíblico completo · 73 mapas + 4 bonos
              </p>
              <p className="font-sans text-xs text-parchment/55" data-id="element-236" data-mp="gvfbcjxukl55">
                <span className="line-through" data-id="element-237" data-mp="gxs1hkdre1ta">{launchOffer.regularPrice}</span> hoy{' '}
                <span className="font-semibold text-gold-soft" data-id="element-238" data-mp="c3ntcxsrbnqm">{launchOffer.price}</span>
              </p>
            </div>
            <CtaButton size="block" href={checkoutUrl} className="sm:w-auto sm:px-8" data-id="element-239" data-mp="py84ytui58y5">
              🙏 Quiero acceder — {launchOffer.price}
            </CtaButton>
          </div>
        </motion.div>}
    </AnimatePresence>;
}